module.exports = __webpack_public_path__ + "static/robinhood-7f7906ee4a9dbac3369862396795e0c6.jpg";